import { metrics } from './metrics';
import { traces } from './traces';
import { logs } from './logs';
import { spans } from './spans';

export const signals = {
  metrics,
  traces,
  logs,
  spans,
};
